<template>
  <el-dialog
    title="选择已有开票记录"
    :visible="visible"
    :before-close="handleCloseDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    width="800px"
  >
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="已有开票记录">
        <el-input placeholder="请输入开票流程编号"
                  v-model="formInline.requestNo"
                  style="width: 200px;"
                  clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleFind">查找</el-button>
      </el-form-item>
    </el-form>

    <template v-if="isSearch">
      <el-table v-loading="tableLoading"
                @selection-change="handleSelectionChange"
                :empty-text="emptyText"
                ref="multipleTable"
                :data="tableData">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="requestNo" label="流程编号" align="center" />
        <el-table-column prop="totalAmount" label="合计金额" align="center" />
        <el-table-column prop="applierName" label="申请人" align="center" />
      </el-table>
      <div style="text-align: center; margin-top: 10px;">
        <el-button style="margin-right: 20px;" @click="handleCloseDialog">关 闭</el-button>
        <el-button v-if="tableData && tableData.length" type="primary" @click="handleSubmit" v-loading="loading">确 定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import servicesInside from '~api/compact-inside';

export default {
  props: {
    contractId: {
      type: String,
    },
    info: Object,
  },
  data() {
    return {
      visible: false,
      formInline: {
        requestNo: '', // 编号
      },
      emptyText: '没有查到您要的数据，请检查后重新操作',
      tableData: [],
      tableLoading: false,
      multipleSelection: [],
      isSearch: false,
      loading: false,
    }
  },
  methods: {
    open() {
      this.visible = true
      this.isSearch = false
      this.formInline.requestNo = ''
      this.tableData = []
    },
    handleCloseDialog() {
      this.visible = false
      this.isSearch = false
      this.formInline.requestNo = ''
      this.tableData = []
      this.multipleSelection = []
    },
    async handleFind() {
      try {
        if (!this.formInline.requestNo) {
          this.$message({
            message: '请输入开票流程编号！',
            type: 'warning',
          })
          return
        }
        this.isSearch = true
        const param = {
          requestNo: this.formInline.requestNo,
          contractId: this.contractId,
        }
        this.tableLoading = true
        const { data } = await servicesInside.queryInvoiceFromOa(param)
        if (data.data === null) {
          this.tableData = []
        } else {
          this.tableData = [data]
        }
        this.tableLoading = false
      } catch (e) {
        console.log(e)
        this.tableLoading = false
      }
    },
    handleSelectionChange(value) {
      this.multipleSelection = value;
    },
    async handleSubmit() {
      if (!this.multipleSelection.length) {
        this.$message({
          message: '请选择要添加的开票记录！',
          type: 'warning',
        })
        return
      }
      try {
        const row = this.multipleSelection[0]
        const {
          overdueDate,
          receivablePlanId,
          applierId,
          applierTeamId,
          invoiceReceivable,
          requestNo,
          status,
          sellerName,
          fileIds,
          detailList,
        } = row
        const param = {
          contractId: this.contractId, // 合同id
          contractNo: this.info.contractNo, // 合同编号
          overdueDate, // 应收款逾期起算日期
          receivablePlanId, // 回款计划id
          applierId, // 业务申请人id
          applierTeamId, // 申请部门id
          invoiceReceivable, // 发票收款id
          requestNo, // 流程编号
          status, // 流程状态
          sellerName, // 销售方名称
          fileIds, // 附件ids
          detailList,
        }
        this.loading = true
        await servicesInside.crmInvoiceRecordSaveInvoice(param)
        this.$message({
          type: 'success',
          message: '关联成功!',
        });
        this.handleCloseDialog()
        this.$emit('success')
        this.loading = false
      } catch (e) {
        console.log(e)
        this.loading = false
      }
    },
  },
}
</script>
